import React, { useState, useRef, useEffect } from 'react';
import { ReactSVG } from "react-svg";
import i18n from "../../i18n/i18n.js";
import TypedLink from '../../components/TypedLink/TypedLink';
import {useAppContext, useModalsContext, withAppContext } from '../../contexts/AppContext';
import './SublevelsCategoryPicker.css';
import { Link } from 'react-router-dom';
import { object, s } from 'framer-motion/client';



const SublevelsCategoryPicker = (props) => {
  const appContext = useAppContext();
  const appRef = appContext.appRef.current;
  const modalsContext = useModalsContext();

  const category = (props.category) ? { ...props.category } : null;
  const mainCategoryId = category?.id || category?.url || null;

  const categories = (category.sublevels) ? { ...category.sublevels } : {};
  const orderBy = (category.order_by) ? [ ...category.order_by ] : [];
  
  // Elmentett 2. szintű kategória lekérdezése
  const getSavedSublevel = () => {
    if (!mainCategoryId || !appRef?.state?.selectedSublevels) return null;
    const saved = appRef.state.selectedSublevels[mainCategoryId];
    // Csak akkor használjuk, ha létezik az orderBy-ban és van sublevels-e
    if (saved && orderBy.includes(saved) && categories[saved]?.sublevels && categories[saved]?.order_by?.length > 0) {
      return saved;
    }
    return null;
  };

  const getInitialActiveKey = () => {
    const saved = getSavedSublevel();
    if (saved) return saved;
    return orderBy.length > 0 ? orderBy[0] : null;
  };

  const [activeKey, setActiveKey] = useState(getInitialActiveKey);
  const prevOrderByRef = useRef(orderBy);
  const prevMainCategoryIdRef = useRef(mainCategoryId);

  const sublevels = (categories[activeKey]?.sublevels) ? { ...categories[activeKey].sublevels } : {};
  const sublevelsOrderBy = (categories[activeKey]?.order_by) ? [ ...categories[activeKey].order_by ] : [];
  const mainCategoryUrl = category ? category.url : '';

  // Mentjük a kiválasztott alkategóriát az appRef-be
  const saveSelectedSublevel = (key) => {
    if (!mainCategoryId || !appRef) return;
    const currentSelected = appRef.state.selectedSublevels || {};
    appRef.setState({
      selectedSublevels: {
        ...currentSelected,
        [mainCategoryId]: key
      }
    });
  };

  // activeKey változásakor mentés
  useEffect(() => {
    if (activeKey && mainCategoryId) {
      saveSelectedSublevel(activeKey);
    }
  }, [activeKey, mainCategoryId]);

  useEffect(() => {
    // Ha változott a főkategória, próbáljuk betölteni a mentett értéket
    const prevMainCategoryId = prevMainCategoryIdRef.current;
    if (prevMainCategoryId !== mainCategoryId) {
      const saved = getSavedSublevel();
      if (saved) {
        setActiveKey(saved);
      } else if (orderBy.length > 0) {
        setActiveKey(orderBy[0]);
      }
      prevMainCategoryIdRef.current = mainCategoryId;
      prevOrderByRef.current = orderBy;
      return;
    }

    // Csak akkor állítsd be újra, ha tényleg változott az orderBy
    const prevOrderBy = prevOrderByRef.current;
    const isDifferent = JSON.stringify(prevOrderBy) !== JSON.stringify(orderBy);
    if (isDifferent) {
      const saved = getSavedSublevel();
      setActiveKey(saved || (orderBy.length > 0 ? orderBy[0] : null));
      prevOrderByRef.current = orderBy;
    }
  }, [orderBy, mainCategoryId]);

  if(!category || orderBy.length === 0){
    return null;
  }
    

  return <div className='sublevels-category-picker'>

    <div className='secound-level-container'>
    {orderBy.map((key, idx) => {
      const cat = categories[key];
      let isActive = activeKey === key || (!activeKey && idx === 0);
      const image = (cat.app_category_image) ? process.env.REACT_APP_API_SERVER_URL+'upload_files/categories/'+cat.app_category_image : 'assets/images/no_image_category.png';
      const has_image = (cat.app_category_image) ? true : false;
      const hasSublevels = (cat.sublevels && cat.order_by && cat.order_by.length > 0);

      if(!hasSublevels && isActive){
        isActive = false; // Ha nincs sublevel, akkor ne legyen active, mert nem lesz megnyitva
      }
      
      const itemContent = (
        <div className={'secound-level-item'+(isActive ? ' active' : '')+(has_image ? '' : ' no-image')}>
          <span className='image-cont'><img src={image} alt={cat.category || ''} /></span>
          <span className='category-name'>{cat.category || ''}</span>
        </div>
      );

      if (hasSublevels) {
        return (
          <div onClick={() => setActiveKey(key)} key={key}>
            {itemContent}
          </div>
        );
      } else {
        return (
          <TypedLink link={{type: 'products', url: mainCategoryUrl+'/'+cat.url}} key={key}>
            {itemContent}
          </TypedLink>
        );
      }
    })}
    </div>

    <div className='third-level-container' >
    {(sublevelsOrderBy.length > 0) ? sublevelsOrderBy.map((subkey, subidx) => {
      const subcat = sublevels[subkey];
      const subimage = (subcat.app_category_image) ? process.env.REACT_APP_API_SERVER_URL+'upload_files/categories/'+subcat.app_category_image : 'assets/images/no_image_category.png';
      const has_image = (subcat.app_category_image) ? true : false;
    
      return <div className={'third-level-item'+(has_image ? '' : ' no-image')} key={subkey}>
        <TypedLink link={{type: 'products', url: mainCategoryUrl+'/'+categories[activeKey].url+'/'+subcat.url}}>
        <div className='image-cont'><img src={subimage} alt={subcat.category || ''} /></div>
        <div className='category-name'>{subcat.category || ''}</div>
        </TypedLink>
      </div>;
        
      
    }) : ''}
    </div>

  </div>
};

export default withAppContext(SublevelsCategoryPicker);